import React from "react";
import { Routes, Route } from "react-router-dom";
import LandingPage from "../pages/LandingPage";
import AboutUs from "../pages/AboutUs/AboutUs";
import VenuePage from "../pages/Venue/Venue";
import SpeakerPage from "../pages/Speakers/Speaker";
import FunPage from "../pages/WhatsFun/Fun";
import AgendaPage from "../pages/Agenda/Agenda";
import SuccessInMotion from "../pages/SuccessInMotion/SuccessInMotion";
import OurTeam from "../pages/OurTeam/OurTeam";


const AppRoutes: React.FC = () => {
  return (
    <Routes>
    <Route path="/" element={<LandingPage />} />
    <Route path="/about-us" element={<AboutUs />} />
    <Route path="/venue" element={<VenuePage />} />
    <Route path="/speakers" element={<SpeakerPage />} />
    <Route path="/whats-fun" element={<FunPage />} />
    <Route path="/program" element={<AgendaPage />} />
    <Route path="/success-in-motion" element={<SuccessInMotion />} />
    <Route path="/our-team" element={<OurTeam />} />
    </Routes>
  );
};

export default AppRoutes;
